import { render, staticRenderFns } from "./MasterKecamatan.vue?vue&type=template&id=2def8c9d&scoped=true"
import script from "./MasterKecamatan.vue?vue&type=script&lang=js"
export * from "./MasterKecamatan.vue?vue&type=script&lang=js"
import style0 from "./MasterKecamatan.vue?vue&type=style&index=0&id=2def8c9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def8c9d",
  null
  
)

export default component.exports